/* eslint-disable @typescript-eslint/explicit-module-boundary-types */

export default class GlobalAllowance {
  private json: any
  public readonly globalAllowanceDisclaimer: string
  public readonly globalAllowanceLabel: string
  public readonly globalAllowanceTooltip: string

  constructor (data: any) {
    this.json = data
    this.globalAllowanceDisclaimer = this.json.disclaimer
    this.globalAllowanceLabel = this.json.label
    this.globalAllowanceTooltip = this.json.tooltip
  }

  static of (data: any): GlobalAllowance {
    return new GlobalAllowance(data)
  }

  static empty (): GlobalAllowance {
    return new GlobalAllowance({
      disclaimer: '',
      label: '',
      tooltip: ''
    })
  }
}
